<template>
  <div class="dao-container">
    <sidebar-modal :active.sync="showSidebar" :title="sidebarTitle"
                   :loading="sidebarLoading" :button="sidebarButton"
                   :destroyLoading='destroyLoading'
                   :destructive="destructiveButton"
                   v-on:action="onSidebarAction"
                   v-on:destroy="onSidebarDestroy"
                   :error.sync="sidebarError"
       >
      <banner :active.sync="bannerActive" :title="jobError" :error="jobError" :time=2000 />
      <component v-bind:is="sidebarComponent" :isCreate="isCreate" v-if="showSidebar"></component>
    </sidebar-modal>
    <div class="title-container">
      <h1 class="title">Vibes DAO</h1>
      <button class="button is-primary" v-if="isWalletConnected" @click="disconnectWallet">DISCONNECT WALLET</button>
      <button class="button is-primary" v-else  @click="connectWallet">CONNECT WALLET</button>
    </div>
  <columns>
    <column size="is-12-mobile is-6-tablet is-6-desktop is-6-widescreen is-6-fullhd">
      <treasury-card></treasury-card>
    </column>
    <column size="is-12-mobile is-6-tablet is-6-desktop is-6-widescreen is-6-fullhd">
      <recent-activity></recent-activity>
    </column>
  </columns>

    <div class="title-container">
      <h1 class="title">Proposal</h1>
      <button  @click="onCreateProposal" class="button is-primary" v-if="isWalletConnected">CREATE PROPOSAL</button>
    </div>
    <columns :is-multiline="true">
      <column size="is-12-mobile is-6-tablet is-4-desktop is-4-widescreen is-3-fullhd">
        <proposal-card :isActive="true"></proposal-card>
      </column>
      <column size="is-12-mobile is-6-tablet is-4-desktop is-4-widescreen is-3-fullhd">
        <proposal-card></proposal-card>
      </column>
      <column  size="is-12-mobile is-6-tablet is-4-desktop is-4-widescreen is-3-fullhd">
        <proposal-card :isActive="true"></proposal-card>
      </column>
      <column size="is-12-mobile is-6-tablet is-4-desktop is-4-widescreen is-3-fullhd">
        <proposal-card></proposal-card>
      </column>
    </columns>
  </div>
</template>

<script>
import TreasuryCard from '../components/dao-community/treasury-card.vue'
import RecentActivity from '../components/dao-community/recent-activity.vue'
import ProposalCard from '../components/dao-community/proposal-card.vue'
import Column from '../components/general/column.vue'
import Columns from '../components/general/columns.vue'
import CreateProposalForm from '../components/dao-community/create-proposal-form.vue'
import SidebarModal from '../components/sidebar-modal.vue'
import Banner from '../components/general/banner.vue'
import {mapMutations, mapState} from 'vuex'

import {authenticate, disconnect, userSession} from '../helpers/stack-auth'

export default {
  name: 'DaoCommunity',
  components: {TreasuryCard, RecentActivity, Column, Columns, ProposalCard, CreateProposalForm, SidebarModal, Banner},
  data () {
    return {
      sidebarTitle: '',
      sidebarComponent: '',
      showSidebar: false,
      sidebarLoading: false,
      sidebarButton: '',
      destructiveButton: '',
      dropdownActive: false,
      dropdownTitle: '',
      destroyLoading: false,
      sidebarError: null,
      jobError: null,
      bannerActive: false,
      isCreate: false,
      isWalletConnected: false
    }
  },
  computed: {
    ...mapState('daoCommunity', ['title', 'briefSummary', 'proposalDescription', 'rationale', 'implementationPlan', 'timeline', 'expectedOutcomes', 'totalAmount', 'initialRequest'])

  },
  mounted () {
    this.isConnected()
  },
  methods: {
    ...mapMutations('daoCommunity', ['setTitleError', 'setBriefSummaryError', 'setProposalDescriptionError', 'setRationaleError', 'setImplementationPlanError', 'setTimelineError', 'setExpectedOutcomesError', 'setTotalAmountError', 'setInitialRequestError']),
    isConnected () {
      if (userSession.isUserSignedIn()) {
        this.isWalletConnected = true
      } else {
        this.isWalletConnected = false
      }
    },
    isPending () {
      return userSession.isSignInPending()
    },
    async connectWallet () {
      await authenticate(() => {
        this.isConnected()
      }, '/dao-community')
    },
    async disconnectWallet () {
      await disconnect('/dao-community')
    },
    onCreateProposal () {
      this.sidebarLoading = false
      this.sidebarButton = 'SUBMIT PROPOSAL'
      this.showSidebar = true
      this.sidebarComponent = 'CreateProposalForm'
      this.sidebarTitle = 'Create Proposal'
      this.isCreate = true
    },
    validateForm () {
      if (this.title.length === 0) {
        this.setTitleError('Title is required')
        return false
      } else if (this.briefSummary.length === 0) {
        this.setBriefSummaryError('Brief summary is required')
        return false
      } else if (this.proposalDescription.length === 0) {
        this.setProposalDescriptionError('Proposal description is required')
        return false
      } else if (this.rationale.length === 0) {
        this.setRationaleError('Rationale is required')
        return false
      } else if (this.implementationPlan.length === 0) {
        this.setImplementationPlanError('Implementation plan is required')
        return false
      } else if (this.timeline.length === 0) {
        this.setTimelineError('Timeline is required')
        return false
      } else if (this.expectedOutcomes.length === 0) {
        this.setExpectedOutcomesError('Expected outcome is required')
        return false
      } else if (this.totalAmount.length === 0 || parseInt(this.totalAmount) === 0) {
        this.setTotalAmountError('Total amount is required')
        return false
      } else if (this.totalAmount < 0) {
        this.setTotalAmountError('Total amount cannot be negative')
        return false
      } else if (this.initialRequest.length === 0 || parseInt(this.initialRequest) === 0) {
        this.setInitialRequestError('Initial request is required')
        return false
      } else if (this.initialRequest < 0) {
        this.setInitialRequestError('Initial request cannot be negative')
        return false
      } else if (this.initialRequest > 100) {
        this.setInitialRequestError('Initial request cannot be 100')
        return false
      }
      return true
    },

    async onSidebarAction () {
      if (this.sidebarLoading || this.destroyLoading) { return }
      this.sidebarError = null
      switch (this.sidebarComponent) {
        case 'CreateProposalForm': {
          const isValid = this.validateForm()
          if (!isValid) {
            return false
          }
          // this.sidebarLoading = true
          // try {
          //   await this.createJob()
          //   this.showSidebar = false
          //   this.clearJobForm()
          // } catch (error) {
          //   this.sidebarError = error.message
          // }
          // this.sidebarLoading = false
          break
        }
        case 'EditJobForm': {
          // this.sidebarLoading = true
          // try {
          //   await this.updateJob()
          //   this.showSidebar = false
          //   this.clearJobForm()
          // } catch (error) {
          //   this.sidebarError = error.message
          // }
          // this.sidebarLoading = false
          break
        }
        default: break
      }
    },
    async onSidebarDestroy () {
      switch (this.sidebarComponent) {
        case 'EditJobForm': {
          this.dropdownTitle = 'Remove Job?'
          this.dropdownActive = true
        }
      }
    }
  }
}
</script>
<style scoped>

.dao-container{
  padding: 0 26px 26px 26px;
  width: 100%;
}

.title-container{
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 26px;
}

@media (max-width: 760px) {
  .title-container{
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: start;
  }
}

.title{
  color: #000;
  text-align: center;
  font-size: 36px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  margin: 0;
}
</style>



// WEBPACK FOOTER //
// src/pages/dao-community.vue